/* Types */
import { Item } from '~/types/api/api-v3/basket'
import { Modification } from '~/types/api/api-v3/product'

/**
 * Формирование объекта под сигнатуру модификации
 * @param item - продукт корзины
 */
export const formatProductForModification = (
  item?: Item,
): Partial<Modification> | null => {
  if (!item) return null

  return {
    id: item.product_id,
    name: item.title,
    full_name: item.title,
    price: item.price,
  }
}
